import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import InstrumentIcon from "../../../../components/instrument-icon";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import Big from "big.js";
import {useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import associateServices from "../../../../services";
import MATH_HELPER from "../../../../helpers/math-helper";
import InformationToast from "../../../../components/toast/InformationToast";
import WithdrawCurrencyDropdown from "./currency-dropdown";
import {decrypt, encrypt} from "../../../../helpers/encryption";
import WithdrawDepositToast from "../../../../components/toast/WithdrawToast";
import store from "../../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../../actions/authentication-actions";

const SwapModal = props => {
    const {
        selectedWallet,
        currencyList,
        currencies,
        selectedFiat,
    } = useSelector(state => state.authenticationReducer)

    const {
        modalCurrency,
    } = useSelector(state => state.globalReducer)
    const [rates, setRates] = useState({})
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const {t} = useTranslation()
    const [data, setData] = useState({})
    const [fromCurrency, setFromCurrency] = useState({})
    const [targetCurrency, setTargetCurrency] = useState({})


    const [_, setSearchParams] = useSearchParams()
    const [step, setStep] = useState('form')

    const [instance, setInstance] = useState({
        address: '',
        amount: '',
        otp: '',
    })


    useEffect(() => {
        const handler = setTimeout(() => {
            if (fromCurrency?.code && targetCurrency?.code && instance?.amount) {
                const body = {
                    from: fromCurrency?.code,
                    to: targetCurrency?.code,
                    amount: instance.amount,
                };
                associateServices.getSwapResults(body).then((res) => {
                    setData(res?.data || {});
                });
            }
        }, 400); // Adjust the delay to 400-500 ms

        // Cleanup function to cancel the timeout if dependencies change
        return () => clearTimeout(handler);

    }, [targetCurrency?.code, fromCurrency?.code, instance.amount])

    const handleReset = () => {
        setStep('form')
        handleChange('otp', '')
    }


    useEffect(() => {
        if (modalCurrency) {
            const theWalletMe = currencyList.find(i => i.code === modalCurrency)
            setFromCurrency(theWalletMe)

            const targetWallet = currencyList.find(i => i.code !== modalCurrency)
            setTargetCurrency(targetWallet)

        } else if (selectedWallet?.code) {
            const theWalletMe = currencyList.find(i => i.code === selectedWallet?.code)
            setFromCurrency(theWalletMe)

            const targetWallet = currencyList.find(i => i.code !== selectedWallet?.code)
            setTargetCurrency(targetWallet)

        }
    }, [selectedWallet, modalCurrency])


    const handleWithdraw = () => {
        if (loading)
            return false;

        let amount = instance.amount
        if (selectedFiat)
            amount = Big(instance.amount || 0).times(rates[fromCurrency?.code] || 0).toFixed(8)


        const body = {
            ...instance,
            code: fromCurrency.code,
            amount
        }
        body.amount = body?.amount?.replace(/,/g, '.')

        if (!MATH_HELPER.isNumeric(body.amount))
            return toast.error(t(`general.enter-a-valid-amount`))


        setLoading(true)

        associateServices.withdraw(body).then(res => {

            setLoading(false)

            if (res?.status !== 200) {
                return toast(<InformationToast
                    icon={'ti-error-404'}
                    title={'...'}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            }

            if (step === 'form') {
                if (res?.data?.step === 'email' || res?.data?.step === '2factor') {
                    setStep(res?.data?.step || '')
                    handleChange('secret', res?.data?.secret)
                }
            } else {

                const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

                associateServices.getWallets({}).then(handleUserWallets)


                if (res?.data === 'withdraw-request-submitted')
                    toast(<WithdrawDepositToast
                        amount={amount}
                        code={fromCurrency?.code}
                        title={t(`api-notifications.${res.data}`)}
                    />)

                handleReset()
            }
        })


    }
    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))

    const handleChange = (type, value) => {
        if (type === 'amount') {
            if (value === '' || regex.test(value)) {
                setInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }
    const handleChangeWallet = wall => {

        if (wall.code === fromCurrency?.code)
            return true

        setSearchParams({
            modal: 'wallet',
            tab: 'swap',
            currency: wall.code,
        })

        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setFromCurrency(wall)

    }
    const handleChangeWalletTarget = wall => {

        if (wall.code === fromCurrency?.code)
            return true


        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setTargetCurrency(wall)

    }


    useEffect(() => {

        if (selectedFiat) {

            console.log('selectedFiat = ', selectedFiat)
            const handleFiatRates = e => {
                const data = decrypt(e)

                console.log('rates - ', rates)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)


        }

    }, [selectedFiat])

    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(instance?.amount || 0).toFixed(8)} ${fromCurrency?.code}`

        return `${Big(instance.amount || 0).times(rates[fromCurrency?.code] || 0).toFixed(8)} ${fromCurrency?.code}`
    }

    const handleSetMax = () => {
        if (!selectedFiat)
            return handleChange('amount', Big(fromCurrency?.balance || 0).toFixed(8))

        return handleChange('amount', Big(fromCurrency.balance || 0).div(rates[fromCurrency?.code] || 0).toFixed(2))


    }
    return (

        <>
            <div className="modal__drops gap-2">

                <WithdrawCurrencyDropdown currencyList={currencyList}
                                          handleChangeWallet={handleChangeWallet}
                                          selectedCurrency={fromCurrency}/>


                <WithdrawCurrencyDropdown currencyList={currencyList}
                                          handleChangeWallet={handleChangeWalletTarget}
                                          selectedCurrency={targetCurrency}/>

            </div>

            <div className="modal__form">

                <div className="form__group">
                    <label htmlFor="" className="form__label form__label--max">
                        {t('modals.wallet.withdraw.amount')} <b>*</b>
                        <span>
                                                {/*{Big(fromCurrency?.balance || 0).toFixed(8)}*/}

                            {getDisplayCurrency()}
                            {/*${Big(instance?.amount || 0).times(conversion?.conversion || 0).toFixed(2)}*/}
                                            </span>
                    </label>
                    <div className="form__amount">
                        <input
                            pattern="[0-9]*"
                            inputMode="numeric"
                            value={instance.amount}
                            onChange={e => handleChange('amount', e.target.value)}
                            type="text" className="form__input"/>

                        <div className="form__coin">
                            <InstrumentIcon code={selectedFiat || fromCurrency?.code}/>
                        </div>
                        <button className="form__max" type="button"

                                onClick={handleSetMax}>
                            {/*onClick={e => handleChange('amount', Big(fromCurrency?.balance || 0).toFixed(8))}>*/}
                            {t('modals.wallet.withdraw.max')}
                        </button>
                    </div>
                </div>
                <div className="form__group">
                    <label htmlFor="" className="form__label">
                        {t('modals.wallet.withdraw.code-address', {
                            code: fromCurrency?.code
                        })} <b>*</b>
                    </label>
                    <div className="form__amount">
                        <input
                            pattern="[0-9]*"
                            inputMode="numeric"
                            value={data?.result || ''}
                            disabled
                            type="text" className="form__input"/>

                        <div className="form__coin">
                            <InstrumentIcon code={targetCurrency?.code}/>
                        </div>
                        <button className="form__max" type="button">
                            {t('swap.result','Result')}
                        </button>
                    </div>

                </div>


                <FormButton onClick={handleWithdraw}
                            label={t('modals.wallet.withdraw.withdraw')}
                            disabled={loading || disabled}
                            loading={loading}
                />


            </div>

        </>
    )

}


export default SwapModal
